import type React from "react";
import { ReactComponent as Svg } from "./assets/synchronize-arrows-1.svg";
import * as styles from "./Icon.module.scss";

type RefreshProps = React.SVGProps<SVGSVGElement>;

export const Refresh = ({ className, ...props }: RefreshProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
